module.exports = __webpack_public_path__ + "static/media/bg_about.4adba18b.jpg";